
/* START_TEMPLATE */
define('hbs!app/templates/question',['hbs','Handlebars'], function( hbs, Handlebars ){ 
var t = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  var stack1, lambda=this.lambda, escapeExpression=this.escapeExpression;
  return "<small>("
    + escapeExpression(lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.resources : depth0)) != null ? stack1.PrimaryResources : stack1)) != null ? stack1.Optional : stack1), depth0))
    + ")</small>";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, lambda=this.lambda, buffer = "<label style=\"padding:0px 0px 10px 10px\" name=\""
    + escapeExpression(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"name","hash":{}}) : helper)))
    + "\" class=\"question-label\">\n    "
    + escapeExpression(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"title","hash":{}}) : helper)))
    + "&nbsp;";
  stack1 = helpers.unless.call(depth0, (depth0 != null ? depth0.required : depth0), {"name":"unless","hash":{},"fn":this.program(1, data),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "<br />\n    <small class=\"question-required-text\" name=\""
    + escapeExpression(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"name","hash":{}}) : helper)))
    + "-small\" style=\"display: none\"><b>"
    + escapeExpression(lambda(((stack1 = (depth0 != null ? depth0.text : depth0)) != null ? stack1.TitleIsRequired : stack1), depth0))
    + "</b></small>\n</label>\n\n";
}});
Handlebars.registerPartial('app/templates/question', t);
return t;
});
/* END_TEMPLATE */
;
